import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Preloader
import Preloader from './components/layouts/Preloader';
// Pages
import Home from './components/pages/Home';
// import Hometwo from './components/pages/Hometwo';
// import Homethree from './components/pages/Homethree';
import About from './components/pages/About';
import Blog from './components/pages/Blog';
import Bloggrid from './components/pages/Bloggrid';
// import Blogstandard from './components/pages/Blogstandard';
import Blogdetail from './components/pages/Blogdetail';
// import Portfolio from './components/pages/Portfolio';
// import Portfoliotwo from './components/pages/Portfoliotwo';
import Portfoliodetail from './components/pages/Portfoliodetail';
import Service from './components/pages/Service';
// import Servicetwo from './components/pages/Servicetwo';
// import Servicedetail from './components/pages/Servicedetail';
import Shop from './components/pages/Shop';
import Productdetail from './components/pages/Productdetail';
import Team from './components/pages/Team';
// import Teamdetail from './components/pages/Teamdetail';
// import Careers from './components/pages/Careers';
import Contact from './components/pages/Contact';
// import Faq from './components/pages/Faq';

import Pod from './components/Pod';
import Companies from './components/pages/Companies';
import Properties from './components/pages/Properties';
import Time from './components/pages/Time';

import ErrorPage from './components/pages/404.js';

export default function App() {

  const OpenGraph = ({ title, description, image }) => (
    <>
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="article" />
    </>
);

  return (
    <Router>
      <Preloader />

      <OpenGraph
        title={'Default Title'}
        description={'Default Description'}
        image={'Default Image URL'}
      />

      <Switch>
        <Route exact path="/" component={Home} />
        {/* <Route path="/hometwo" component={Hometwo} /> */}
        {/* <Route path="/homethree" component={Homethree} /> */}
        <Route path="/about" component={About} />
        <Route exact path="/blog" component={Blog} />
        <Route path="/bloggrid" component={Bloggrid} />
        {/* <Route path="/blogstandard" component={Blogstandard} /> */}
        {/* <Route path="/blogdetail" component={Blogdetail} /> */}
        {/* <Route path="/portfolio" component={Portfolio} /> */}
        {/* <Route path="/portfoliotwo" component={Portfoliotwo} /> */}
        <Route path="/topics" component={Portfoliodetail} />
        <Route path="/service" component={Service} />
        {/* <Route path="/servicetwo" component={Servicetwo} /> */}
        {/* <Route path="/servicedetail" component={Servicedetail} /> */}
        <Route path="/shop" component={Shop} />
        <Route path="/shopdetail" component={Productdetail} />
        <Route path="/team" component={Team} />
        {/* <Route path="/teamdetail" component={Teamdetail} /> */}
        {/* <Route path="/careers" component={Careers} /> */}
        <Route path="/contact" component={Contact} />
        <Route path="/time" component={Time} />
        {/* <Route path="/faq" component={Faq} /> */}
        <Route path="/podcasts" component={Pod} />
        <Route path="/companies" component={Companies} />
        <Route path="/properties" component={Properties} />
        <Route path="/blog/:slug" component={Blogdetail} />

        <Route exact path="/*" component={ErrorPage} />

      </Switch>
    </Router>

  )
}
